class TailleAttribute {
  constructor() {
    this.addToCartButton = document.querySelector('#add_to_cart_button');
    this.addedToCartMessage = document.querySelector('#added_to_cart_message');
    this.tailleAttributeButton = document.querySelectorAll(
      '.taille-attribute-button'
    );
    this.closeCartNoticeButton = document.querySelector('#close-cart-notice');
    this.currentItemButtons = document.querySelectorAll('.current-1');
    this.miniCartIcon = document.querySelectorAll('.mini-cart-icon');

    this.addToCartUrl = null;
    this.selectedTaille = null;

    this.cartCount = 0;

    this.events();
  }

  events() {
    this.tailleAttributeButtonClicked();
    this.addToCartButtonClicked();
    this.closeCartNoticeButtonClicked();
    this.disableCurrentItemButtons();
  }

  /**
   * Construct url based on dom attributes of the selected taille pa_atribute
   * @since 1.0.0
   * @returns constructed url
   */
  constructCartUrl() {
    const url =
      window.location.href +
      '?add-to-cart=' +
      this.selectedTaille.productId +
      '&variation_id=' +
      this.selectedTaille.variationId +
      '&attribute_pa_taille=' +
      this.selectedTaille.slug;
    return url;
  }

  /**
   * Increment min cart icon count
   * @since 1.0.0
   */
  incrementIconCount() {
    console.log('_INCREMENT...');
    if (this.miniCartIcon) {
      this.miniCartIcon.forEach((icon) => {
        let data_attribute_count = '';
        if (icon.getAttribute('data-count')) {
          if (icon.getAttribute('data-count')) {
            const count = icon.getAttribute('data-count');
            let num = Number(count);
            console.log(num);

            if (Number.isInteger(num) && num >= 0) {
              icon.innerHTML = num + 1;
              icon.setAttribute('data-count', num + 1);
              // console.log('integer');
            } else {
              // console.log('not integer');
            }
          }
        }
      });
    }
  }

  /**
   * Display added to cart message
   * @since 1.0.0
   */
  displayAddedToCartNotice() {
    if (this.addedToCartMessage) {
      this.addedToCartMessage.classList.remove('hidden');
      this.addedToCartMessage.classList.add('flex');
      setTimeout(() => {
        this.addedToCartMessage.classList.add('hidden');
      }, 4000);
    }
  }

  /**
   * Hide added to cart message
   * @since 1.0.0
   */
  hideAddedToCartNotice() {
    if (this.addedToCartMessage) {
      this.addedToCartMessage.classList.remove('flex');
      this.addedToCartMessage.classList.add('hidden');
    }
  }

  /**
   * Add to cart button clicked
   * @since 1.0.0
   */
  addToCartButtonClicked() {
    // if (this.addToCartButton)
    //   this.addToCartButton.addEventListener('click', (e) => {
    //     e.preventDefault();

    //     // // ADD TO CART METHOD
    //     // var xmlhttp = new XMLHttpRequest();
    //     // xmlhttp.onreadystatechange = function () {
    //     //   if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
    //     //     var response = xmlhttp.responseText; //if you need to do something with the returned value
    //     //   }
    //     // };
        
    //     // xmlhttp.open('GET', this.addToCartUrl, true);
    //     // xmlhttp.send();
    //     // // ADD TO CART METHOD

    //     // this.displayAddedToCartNotice();
    //     // this.incrementIconCount();
    //   });
  }

  // async testCartAsync() {
  //   if (this.addToCartButton)
  //     this.addToCartButton.addEventListener('click', (e) => {
  //       e.preventDefault();
  //       let response = await new Promise(resolve => {
  //         // var xhr = new XMLHttpRequest();
  //         // xhr.open("GET", url, true);
  //         // xhr.onload = function(e) {
  //         //   resolve(xhr.response);
  //         // };
  //         // xhr.onerror = function () {
  //         //   resolve(undefined);
  //         //   console.error("** An error occurred during the XMLHttpRequest");
  //         // };
  //         // xhr.send();
  //         // ADD TO CART METHOD
  //         var xmlhttp = new XMLHttpRequest();
  //         xmlhttp.onreadystatechange = function () {
  //           if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
  //             var response = xmlhttp.responseText; //if you need to do something with the returned value
  //           }
  //         };
          
  //         xmlhttp.open('GET', this.addToCartUrl, true);
  //         xmlhttp.send();
  //         // ADD TO CART METHOD
  //      }) 
  //     //  doTheThing(response)

  //       this.displayAddedToCartNotice();
  //       this.incrementIconCount();
  //     });

  // }

  /**
   * Notice close button clicked
   * @since 1.0.0
   */
  closeCartNoticeButtonClicked() {
    if (this.closeCartNoticeButton) {
      this.closeCartNoticeButton.addEventListener('click', (e) =>
        this.hideAddedToCartNotice()
      );
    }
  }

  /**
   * Disable current item buttons
   * @since 1.0.0
   */
  disableCurrentItemButtons() {
    if (this.currentItemButtons.length > 0) {
      this.currentItemButtons.forEach((button) => {
        button.disabled = true;
        button.style.cursor = 'default';
      });
    }
  }

  /**
   * Get opposite for bool
   * @since 1.0.0
   * @return bool
   */
  oppositeBool(bool) {
    let selected = false;
    selected = bool == 'true' ? true : false;
    return selected;
  }

  /**
   * Set selected for attribute button
   * @since 1.0.0
   */
  setSelectedBool(button) {
    button.setAttribute(
      'data-selected',
      this.oppositeBool(button.getAttribute('data-selected'))
    );
  }

  /**
   * Taille attribute button clicked
   * @since 1.0.0
   */
  tailleAttributeButtonClicked() {
    if (this.tailleAttributeButton.length > 0) {
      this.tailleAttributeButton.forEach((button, i) => {
        button.addEventListener('click', () => {
          //   button.setAttribute("data-selected", true);
          let dataSelectedBool = JSON.parse(
            button.getAttribute('data-selected').toLowerCase()
          );
          button.setAttribute('data-selected', !dataSelectedBool);
          this.tailleAttributeButton.forEach((element, ie) => {
            if (i !== ie) {
              let dataSelectedBoolE = JSON.parse(
                element.getAttribute('data-selected').toLowerCase()
              );
              dataSelectedBoolE &&
                element.setAttribute('data-selected', !dataSelectedBoolE);
            }
          });
          // Registering selected attribute data
          this.selectedTaille = {
            slug: button.getAttribute('data-attribute-slug'),
            productId: button.getAttribute('data-product-id'),
            variationId: button.getAttribute('data-variation-id'),
          };
          // Assign result of url constructor function to addToCart Url variable
          this.addToCartButton.setAttribute('data-attribute-slug', this.selectedTaille.slug);
          this.addToCartButton.setAttribute('data-product-id', this.selectedTaille.productId);
          this.addToCartButton.setAttribute('data-variation-id', this.selectedTaille.variationId);
          this.addToCartUrl = this.constructCartUrl();
        });
      });
    }
  }
}

export default TailleAttribute;
